export const NAME = 'SALE';

//General
export const SETSTATE = 'SETSTATE_' + NAME;
export const STATEINIT = 'STATEINIT_' + NAME;
export const ON_CHANGE = 'ON_CHANGE_' + NAME;
export const LOADING = 'LOADING_' + NAME;
export const LOADED = 'LOADED_' + NAME;
export const OPEN_MODAL_ADD = 'OPEN_MODAL_ADD_' + NAME;
export const CLOSE_MODAL_ADD = 'CLOSE_MODAL_ADD_' + NAME;
export const ADD_SERVICE = 'ADD_SERVICE_' + NAME;
export const UPDATE_SERVICE = 'UPDATE_SERVICE_' + NAME;
export const ADD_PACKAGE = 'ADD_PACKAGE_' + NAME;
export const UPDATE_PACKAGE = 'UPDATE_PACKAGE_' + NAME;
export const ADD_OPERATORSPAYMENTS = 'ADD_OPERATORSPAYMENTS' + NAME;
export const UPDATE_OPERATORSPAYMENTS = 'UPDATE_OPERATORSPAYMENTS' + NAME;
export const ADD_LISTPAYMENTS = 'ADD_LISTPAYMENTS' + NAME;
export const UPDATE_LISTPAYMENTS = 'UPDATE_LISTPAYMENTS' + NAME;
export const ADD_FLIGHT = 'ADD_FLIGHT_' + NAME;
export const UPDATE_FLIGHT = 'UPDATE_FLIGHT_' + NAME;
export const ADD_RECEIPT = 'ADD_RECEIPT_' + NAME;
export const UPDATE_RECEIPT = 'UPDATE_RECEIPT_' + NAME;
export const ADD_LODGING = 'ADD_LODGING_' + NAME;
export const UPDATE_LODGING = 'UPDATE_LODGING_' + NAME;

export const FIND = 'FIND_' + NAME;
export const FIND_BY_ID = 'FIND_BY_ID_' + NAME;
export const CREATE = 'CREATE_' + NAME;
export const UPDATE = 'UPDATE_' + NAME;
export const DELETE = 'DELETE_' + NAME;
export const CHANGE_TABLE = NAME + '_CHANGE_TABLE';
export const SEARCH_TABLE = NAME + '_SEARCH_TABLE';



// WEBPACK FOOTER //
// ./src/views/Sales/redux/SalesConstants.jsx